export default __webpack_public_path__ + "locales/it/Errors.json?hash=095a5c1d6babef50a945b7b1e65869c3";